import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import UserInput from '@/components/_custom/UserInput/userInput'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import styles from './duplicateOccasionalSlot.module.scss'
import { Close, ContentCopy } from '@mui/icons-material'
import { DUPLICATE_OCCASIONAL_SLOT } from '@/modules/API/slot/occasionalSlotHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface DuplicateOccasionalSlotDialogProps {
    open: boolean
    handleClose: () => void
    occasionalSlotId: number
    daycareId: number
    refetchData: () => void
    closeParentDialog?: () => void
}

const DuplicateOccasionalSlotDialog: FunctionComponent<DuplicateOccasionalSlotDialogProps> = ({
    open,
    handleClose,
    occasionalSlotId,
    daycareId,
    refetchData,
    closeParentDialog
}: DuplicateOccasionalSlotDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [duplicateCount, setDuplicateCount] = useState<number>(1)

    const [duplicateOccasionalSlot, { loading: loadingDuplicate }] = useMutation(DUPLICATE_OCCASIONAL_SLOT, {
        variables: {
            slotId: occasionalSlotId,
            count: duplicateCount,
            daycareId: daycareId
        },
        onCompleted: () => {
            refetchData()
            if (closeParentDialog) {
                closeParentDialog()
            }
            handleClose()
            showNotificationSuccess(t('occasionalSlotsDuplicated'))
        },
        onError: () => {
            showNotificationError(t('errorDuplicatingOccasionalSlots'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('duplicateOccasionalSlot')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('duplicateOccasionalSlotMessage')}</p>
                <UserInput
                    type={'number'}
                    verify={'number'}
                    label={t('seatsNumber')}
                    value={duplicateCount.toString()}
                    setValue={(value) => setDuplicateCount(parseInt(value))}
                    className={styles.UserInput}
                    minNumber={1}
                    maxNumber={100}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<ContentCopy />}
                        onClick={duplicateOccasionalSlot}
                        className={styles.Button}
                        disabled={loadingDuplicate}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DuplicateOccasionalSlotDialog
